import { useState } from "react";
import { StickyNote, ChevronDown, ChevronUp } from "lucide-react";

export function NotePreview({ item }) {
  const [open, setOpen] = useState(false);
  const when = item.note_updated_at ? new Date(item.note_updated_at).toLocaleDateString("it-IT", { day: "2-digit", month: "short" }) : null;
  const long = item.note.length > 110 || item.note.split("\n").length > 3;
  return (
    <div data-testid={`ssd-note-${item.id}`} onClick={(e) => { e.stopPropagation(); if (long) setOpen((v) => !v); }}
      className={`mt-2.5 rounded-lg bg-amber-50 dark:bg-amber-500/10 border border-amber-200/70 dark:border-amber-500/20 px-2.5 py-1.5 text-[11.5px] leading-snug text-amber-900 dark:text-amber-200 ${long ? "cursor-pointer" : ""}`}>
      <div className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-amber-700/80 dark:text-amber-300/80 mb-0.5">
        <StickyNote className="h-3 w-3" /> Note{when && <span className="normal-case font-normal tracking-normal">· agg. {when}</span>}
        {long && (open ? <ChevronUp className="h-3 w-3 ml-auto" /> : <ChevronDown className="h-3 w-3 ml-auto" />)}
      </div>
      <div className={`whitespace-pre-line break-words ${open ? "" : "line-clamp-3"}`}>{item.note}</div>
    </div>
  );
}
